import React from 'react';
import { Row, Button, FormGroup, HelpBlock } from 'react-bootstrap';
import Multiselect from 'multiselect-react-dropdown';
import FormLabel from '../../../components/FormLabel/FormLabel';

function AssignInstances({
    franchiseOptions,
    selectedValues,
    onSelectionChange,
    isBusy,
    errorMessage
}) {
    const addAll = () => {
        const options = (franchiseOptions || []).map((franchise) => ({ id: franchise.id, name: `${franchise.name}` }));
        onSelectionChange(options);
    };

    const clearAll = () => {
        onSelectionChange([]);
    };

    const addCorporate = () => {
        const options = (franchiseOptions || [])
            .filter(v => v.corporateOwned === true)
            .map((franchise) => ({ id: franchise.id, name: `${franchise.name} ` }));
        onSelectionChange(options);
    };

    const addNonCorporate = () => {
        const options = (franchiseOptions || [])
            .filter(v => v.corporateOwned !== true)
            .map((franchise) => ({ id: franchise.id, name: `${franchise.name}` }));
        onSelectionChange(options);
    };

    return (
        <>
            <Row>
                <div className="col-md-12 mt-1">
                    <div style={{ borderBottom: '1px solid #b7b7bd', marginBottom: '20px' }}>
                        <h4><strong>Assign Instances</strong></h4>
                    </div>
                </div>
            </Row>
            <Row>
                <div className="col-md-12">
                    <FormGroup validationState={!(!errorMessage) ? 'error' : null}>
                        <div style={{ width: '100%' }}>
                            <FormLabel required='required' hasError={!(!errorMessage)}>Activate For: </FormLabel>
                            <Button style={{ marginLeft: '2rem' }} bsStyle="danger" variant="danger" disabled={isBusy} className="button-group-margin" onClick={addAll}>
                                <i className="fa fa-plus button-icon"></i>Add All
                            </Button>
                            <Button bsStyle="danger" variant="danger" disabled={isBusy} className="button-group-margin" onClick={addCorporate}>
                                <i className="fa fa-plus button-icon"></i>Corporate
                            </Button>
                            <Button bsStyle="danger" variant="danger" disabled={isBusy} className="button-group-margin" onClick={addNonCorporate}>
                                <i className="fa fa-plus button-icon"></i>Non Corporate
                            </Button>
                            <Button bsStyle="default" disabled={isBusy} className="button-group-margin" onClick={clearAll}>
                                <i className="fa fa-refresh button-icon"></i>Clear All
                            </Button>
                            {!!errorMessage && (
                                <HelpBlock><i className="fa fa-exclamation-circle"></i>&nbsp;Instances are Required</HelpBlock>
                            )}
                        </div>
                    </FormGroup>

                    <Multiselect
                        style={{
                            optionContainer: { height: '220px' },
                            multiselectContainer: { maxHeight: '220px' }
                        }}
                        id="franchises"
                        options={franchiseOptions}
                        displayValue="name"
                        disabled={isBusy}
                        placeholder="Select Instances..."
                        emptyRecordMsg="No Instances Available"
                        selectedValues={selectedValues}
                        onSelect={(list) => onSelectionChange(list)}
                        onRemove={(list) => onSelectionChange(list)}
                    />
                    <br />
                </div>
            </Row>
        </>
    );
}

export default AssignInstances;
